import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  textCell: {
    display: 'inline-block',
    fontWeight: 'bolder',
    fontSize: '1rem',
    color: '#3C419A',
    overflow: 'hidden',
    width: '160px',
    paddingTop: '5px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  textCellExaminer: {
    fontWeight: 'bolder',
    fontSize: '1rem',
    color: '#3C419A',
    width: '90px',
    whiteSpace: 'initial',
    wordWrap: 'normal',
    paddingLeft: '10px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'end',
    marginRight: '10px',
    marginBottom: '5px',
    width: '100%'
  }
}));
